import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@shared/services/authentication.service';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  return authService.isAuth().then((isAuth) => {
    if (!isAuth) {
      let redirectTo = '/login';
      authService.redirectURL = state.url;
      if (state.url === '/createProgramHub' || state.url === '/createHub') {
        redirectTo = '/signup';
      }
      return router.parseUrl(redirectTo);
    }
    return isAuth;
  });
};
